import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 23400 20269"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#fefefe;stroke-width:331.32}.fil0{fill:#000}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2283705393712">
        <path
          id="XMLID_446_"
          d="m12058 13195 10520 6068-7199-7990-3326-10226z"
          className="fill storke1"
          style={{
            strokeWidth: 331.32
          }}
        />
        <path
          id="XMLID_447_"
          d="m11342 13195-5-12149-3320 10229-7195 7995z"
          className="fill storke1"
          style={{
            strokeWidth: 331.32
          }}
        />
        <path
          id="XMLID_448_"
          d="M11700 13815 1182 19889l10518-2239 10519 2233z"
          className="fill storke1"
          style={{
            strokeWidth: 331.32
          }}

        />
      </g>
      <path id="XMLID_449_" d="M48 20009z" className="fil0 str0" />
    </g>
  </svg>
)
export default SvgComponent
